export default __webpack_public_path__ + "static/Ellipsis-bw-13-307e0a650bb29259a62ad1e0c70bf651.svg";